module.exports = __webpack_public_path__ + "assets/DINPro-Bold-d3c192a5.otf";